import { DeductionNavbar, GlobalFilters } from "@/app/navbar"
import { SummaryCards } from "@/deduction_table/summary_cards"
import { DetailedMonthlyBreakdownChart } from "./detailed_monthly_breakdown"
import { DetailedMonthlyExpenseBreakdownChart } from "./detailed_monthly_expense_breakdown"
import { MonthlyExpenseAccountGroupBreakdownChart } from "./monthly_expense_account_group_breakdown"
import { MonthlyExpenseAccountGroupExecutionBreakdownChart } from "./monthly_expense_account_group_execution_breakdown"
import { QuarterlyExpenseAccountGroupExecutionBreakdownChart } from "./quarterly_expense_account_group_execution_breakdown"
import { MonthlyBreakdownChart } from "./monthly_breakdown"
// import { CustomerDeductionRateTrendChart } from "./customer_deduction_rate_trend_chart"
import { AnalyticsDashboard } from "@/components/analytics-dashboard"
import { DcDeductionSection } from "./dc_trend_chart"
import { SplitRetailerTrendChart } from "./split_retailer_trend_chart"
import { YoyDeductionTrendChart } from "./yoy_trend_chart"
import { DashboardExportButton } from "./dashboard_export"

export function Sales() {
  return (
    <div class="w-full px-4">
      <DeductionNavbar>
        <GlobalFilters />
      </DeductionNavbar>
      <div className="space-y-8">
        <div className="flex justify-end -mb-6 mt-8">
          <DashboardExportButton />
        </div>
        <SummaryCards />
        <YoyDeductionTrendChart />
        {/* <CustomerDeductionRateTrendChart /> */}
        <div className="grid grid-cols-2 gap-4">
          {/* <DisputedBySourceChart /> */}
          <MonthlyBreakdownChart />
          <DetailedMonthlyBreakdownChart />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <DetailedMonthlyExpenseBreakdownChart />
          <MonthlyExpenseAccountGroupBreakdownChart />
        </div>
        <div className="grid grid-cols-1 gap-4">
          <MonthlyExpenseAccountGroupExecutionBreakdownChart />
        </div>
        <div className="grid grid-cols-1 gap-4">
          <QuarterlyExpenseAccountGroupExecutionBreakdownChart />
        </div>
        <DcDeductionSection />
        <SplitRetailerTrendChart />
        <AnalyticsDashboard />
      </div>
    </div>
  )
}
